/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Servis_S3_HeadingInputs */

const tr_servis_s3_heading = /** @type {(inputs: Servis_S3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Ücret Değişiklikleri`)
};

const en_servis_s3_heading = /** @type {(inputs: Servis_S3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Fee Changes`)
};

const de_servis_s3_heading = /** @type {(inputs: Servis_S3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Änderungen der Gebühren`)
};

const ru_servis_s3_heading = /** @type {(inputs: Servis_S3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Изменение стоимости`)
};

/**
* | output |
* | --- |
* | "3. Fee Changes" |
*
* @param {Servis_S3_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const servis_s3_heading = /** @type {((inputs?: Servis_S3_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Servis_S3_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_servis_s3_heading(inputs)
	if (locale === "de") return de_servis_s3_heading(inputs)
	if (locale === "ru") return ru_servis_s3_heading(inputs)
	return tr_servis_s3_heading(inputs)
});